<template>
<div>
  <div class="vx-row">

   

    <!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full mb-base">
      
      <vx-card title="">
        <div class="demo-alignment">
                  <vs-button @click="stoklariGuncelle()" color="success" type="filled">Stokları Güncelle</vs-button>
                  <vs-button @click="stokResimleri()" color="success" type="filled">Stok Resimleri</vs-button>
            <vs-progress :percent="progress"  v-model="progress"  color="primary"></vs-progress>
        </div>
      </vx-card>
      <br/>

    </div>

    </div>

           
    </div>


    
</template>



<script>
import state from '../../store/state'
import Store from '../../store/store'
import vSelect from 'vue-select'
export default {
  components: {
    'v-select': vSelect,
  },
  data () {
    return {
  list: []
    }
  },methods: {
    stoklariGuncelle() {
     
//alert(document.getElementById('adet_'+id).value)
      var vm = this

      const soap = require('soap')
      const url = state.sistemAddress
      const args = {token:Store.state.tokenId,pazaryeri:''}
      soap.createClient(url, function(err, client){
      client.EntegraUrunCek(args, function(err, result){
        if (result.EntegraUrunCekResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

      /* vm.veriler=JSON.parse(result.gonderimListesineEkleResult)
       console.log(vm.veriler)
        vm.resimYukle(result.gonderimListesineEkleResult,0,id)*/
        if (result.EntegraUrunCekResult=="Ok") {
          alert("Ürünler Güncellendi");
        }
        
     
        
        
      })
     
      })


    },
   stokResimleri() {
     
//alert(document.getElementById('adet_'+id).value)
      var vm = this

      const soap = require('soap')
      const url = state.sistemAddress
      const args = {token:Store.state.tokenId,pazaryeri:'Resim'}
      soap.createClient(url, function(err, client){
      client.EntegraUrunCek(args, function(err, result){
        if (result.EntegraUrunCekResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

      /* vm.veriler=JSON.parse(result.gonderimListesineEkleResult)
       console.log(vm.veriler)
        vm.resimYukle(result.gonderimListesineEkleResult,0,id)*/
        if (result.EntegraUrunCekResult=="Ok") {
          alert("Resimler Güncellendi");
        }
        
     
        
        
      })
     
      })


    }
   
  },
  watch: {
    list: {
      handler: function () {
       
        //this.toplamParca=this.list.reduce((acc, item) => Number(acc) + (Number(item.siparisAdetleri)), 0)
      
      },
      deep: true
    }
  },beforeMount(){
      
              }
  
}

</script>
<style lang="scss" scoped>
.mb-base { margin-bottom: 0.75rem!important;}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
